export default __webpack_public_path__ + "static/media/gas95.cd587e17.svg";